// window.axios = require('axios')
// window.axios.defaults.headers.common = {
// 	'X-CSRF-TOKEN': window.Laravel.csrfToken,
// 	'X-Requested-With': 'XMLHttpRequest'
// }

require('./site/nav')
require('./site/fancybox')
require('./site/swiper')
require('./site/cookies')
require('./site/layout')
require('./site/dark-mode')
require('./site/bootstrap')
require('./site/scroll-reveal')
require('./site/brand')
// require('./site/alert')
// require('./site/anchor')
// require('./site/form-mask')
// require('./site/form-validate')

/*/
 * Blá blá blá
/*/
	function doubleTrouble() {
		if (event.key === 'Control') {
			siteCtrlClicks++
			if (siteCtrlClicks >= 2) {
				confirm(' \n 👨🏼‍🎨 Front-end developer :: https://rcrdk.dev \n 💻 Sou Digital :: https://sou.digital')
			}
			setTimeout(() => (siteCtrlClicks = 0), 200)
		}
	}

	let siteCtrlClicks = 0
	document.addEventListener('keyup', doubleTrouble, true)
